import { useClientRegister } from "contexts/register/ClientContext";
import Input from "../../../Input";
import MaskedInput from "../../../MaskedInput";
import { isEmailValid } from "utils/isEmailValid";

import { useCallback, useEffect, useState } from "react";
import { getUserService } from "services/UserServices";
import { MoneyInput } from "components/MoneyInput";

import * as S from "./styles";

function ClientForm() {
  const { client, setClient, errors, addError, removeError } =
    useClientRegister();
  const [email, setEmail] = useState<string>("");

  const checkIfUserExist = useCallback(async () => {
    // if (!client.id)
    try {
      const userExist = await getUserService({ where: { email } });

      if (userExist.status) {
        addError("emailExists", "E-mail já registrado");
        return;
      }
    } catch {
      removeError("emailExists");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  useEffect(() => {
    if (isEmailValid(email)) {
      checkIfUserExist();
    }
  }, [email, checkIfUserExist]);

  function validateEmail(event: React.ChangeEvent<HTMLInputElement>) {
    const email = event.target.value;

    if (!isEmailValid(email)) {
      addError("corporativeEmail", "E-mail inválido");
      return;
    }

    removeError("corporativeEmail");
  }

  function validateCNPJ(event: React.ChangeEvent<HTMLInputElement>) {
    const rg = event.target.value.replace("_", "");
    if (rg.length < 18) {
      addError("cnpj", "CNPJ inválido");
      return;
    }

    removeError("cnpj");
  }

  return (
    <S.Wrapper>
      <S.Form>
        <Input
          id="managerName"
          name="managerName"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setClient((value) => {
              value.managerName = event.target.value;
              return value;
            });
          }}
          label="Nome proprietário"
          defaultValue={client?.managerName}
          required={true}
          type="text"
          error={errors.managerName || errors["client.managerName"]}
          apiErrorName={"client.managerName"}
          handleApiErrorRemove={() => removeError("client.managerName")}
        />
        <Input
          id="tradingName"
          name="tradingName"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setClient((value) => {
              value.tradingName = event.target.value;
              return value;
            });
          }}
          defaultValue={client?.tradingName}
          label="Razão social"
          required={true}
          type="text"
          error={
            errors.tradingName ||
            errors["client.tradingName"] ||
            errors["clients.tradingName"]
          }
          apiErrorName={"client.tradingName"}
          handleApiErrorRemove={() => removeError("client.tradingName")}
        />
        <MaskedInput
          id="cnpj"
          name="cnpj"
          onBlur={validateCNPJ}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setClient((value) => {
              value.cnpj = event.target.value;
              return value;
            });
          }}
          defaultValue={client?.cnpj}
          label="CNPJ"
          required={true}
          type="text"
          mask="99.999.999/9999-99"
          error={errors["clients.unique_client_cnpj"] || errors["cnpj"]}
          // duplicatedError={errors["user.cnpj"]}
          apiErrorName={"cnpj"}
          handleApiErrorRemove={() => {
            removeError("cnpj");
            removeError("clients.unique_client_cnpj");
          }}
        />
        <Input
          id="email"
          name="email"
          onBlur={validateEmail}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setClient((value) => {
              value.email = event.target.value;
              return value;
            });
            setEmail(event.target.value);
            validateEmail(event);
          }}
          label="E-mail corporativo"
          defaultValue={client?.email}
          required={true}
          type="email"
          error={errors["client.email"] || errors["corporativeEmail"]}
          apiErrorName={"client.email"}
          handleApiErrorRemove={() => removeError("client.email")}
        />
        <Input
          id="name"
          name="name"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setClient((value) => {
              value.name = event.target.value;
              return value;
            });
          }}
          label="Nome fantasia"
          defaultValue={client?.name}
          required={true}
          type="text"
          error={errors.name || errors["client.name"] || errors["clients.name"]}
          apiErrorName={"client.name"}
          handleApiErrorRemove={() => removeError("client.name")}
        />

        {/* <Input
          id="minimum_billing"
          name="minimum_billing"
          onChange={(event) =>
            setClient((value) => {
              value.minimumBilling = Number(event.target.value);
              return value;
            })
          }
          defaultValue={client?.minimumBilling}
          label="Faturamento mínimo"
          required={true}
          type="number"
          containerClassName={styles.infoInput}
          error={errors.name || errors["client.minimumBilling"]}
          apiErrorName={'client.minimumBilling'}
          handleApiErrorRemove={() => removeError('client.minimumBilling')}
        /> */}

        <MoneyInput
          id="minimum_billing"
          name="minimum_billing"
          label="Faturamento mínimo"
          onCurrencyChange={(currency) => {
            if (currency) {
              setClient((value) => {
                value.minimumBilling = currency;
                return value;
              });
            }
          }}
          defaultValue={client?.minimumBilling}
          required
          error={errors["client.minimumBilling"]}
          onFocus={() => removeError("client.minimumBilling")}
        />
      </S.Form>
    </S.Wrapper>
  );
}

export { ClientForm };
